// Mapping of month names to their respective numerical values
const monthMap: { [key: string]: number } = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12,
};

export function sortMonthsChronologicallyWithValues(
  months: (string | number)[],
  values: number[],
) {
  // Pair the months and values values together
  const paired = months.map((month, index) => ({
    month,
    value: values[index],
  }));

  // Sort the paired values by month
  paired.sort((a, b) => monthMap[a.month] - monthMap[b.month]);

  // Separate the months and values again
  const sortedX = paired.map(pair => pair.month);
  const sortedY = paired.map(pair => pair.value);

  return { sortedX, sortedY };
}
